import type { EmployeeAlertResignationDateBeforeHiredDate } from '@/common/graphql';

import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertResignationDateBeforeHiredDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertResignationDateBeforeHiredDate, 'hiredDate' | 'resignationDate'>;
}) => (
  <>
    <div>
      <FormattedDate prefix="Hired date" date={reason.hiredDate} />
    </div>
    <div>
      <FormattedDate prefix="Employment end date" date={reason.resignationDate} />
    </div>
  </>
);
